import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import * as apiClient from "../../api-client";

const BlogSliderHome: React.FC = () => {
  const { data: blogs = [], isLoading } = useQuery('fetchBlogs', apiClient.fetchBlogs);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
  };

  return (
    <Swiper
      spaceBetween={20}
      modules={[Navigation, Pagination]}
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      navigation={{
        nextEl: ".js-blog-next",
        prevEl: ".js-blog-prev",
      }}
      breakpoints={{
        500: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 22,
        },
        1024: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 4,
        },
      }}
    >
      {blogs.slice().reverse().map((item) => (
        <SwiperSlide key={item._id} className="p-0 mb-8 md:mt-3 mt-2">
          <Link to={`/blogs/${item?.slug}`} className="block bg-white rounded-lg shadow overflow-hidden">
            <div className="relative w-full h-0 pb-[56.25%]">
              <img
                className="absolute inset-0 w-full h-full object-cover"
                src={item.imageUrls[1]}
                alt="image"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <h3 className="text-gray-900 text-lg font-semibold line-clamp-2">{item.title}</h3>
              <div className="text-gray-600 text-sm mt-2">{formatDate(item.createdAt.toString())}</div>
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BlogSliderHome;
